import { OverlayContainer } from '@angular/cdk/overlay';
import { Component, ElementRef, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { CommonService } from '../../providers/common.service';
import { Menu, ModelDialogType } from '../../models/menu';
import { CustomTranslateService } from '../../providers/customTranslate.service';
import { MatIconRegistry } from '@angular/material/icon';
import { Constants } from '../../common/constants';
import { FormControl, Validators } from '@angular/forms';
import { SettingswithID, SettingsService } from '../../providers/settings.service';
import { DialogService } from '../../providers/dialogservice';
import { DomSanitizer } from '@angular/platform-browser';
import { LanguageSettings } from '../../providers/languageSettings.service';
import { SearchDataService } from '../../providers/searchDataService';
import { filter } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';

/**
     * Its the Default page loaded once logged in.
     */
@Component({
  selector: 'docs',
  templateUrl: './app-layout.component.html',
  styleUrls: ['./app-layout.component.scss']
})
export class AppLayoutComponent implements OnInit {
  toggle: boolean;
  screenWidth: number;
  dark = false;
  menuList: Menu[] = [];
  darkThemeClass: string;
  lang = 'en';
  /**
     * Trace the routerlink of the currently active component.
     */
  currentRoutePath: string;
  helpPath: string;
  /**
     * Mentions the currently chose language code.
     */
  currentLanguage: string;

  platforms:String[];
  selectedPlatform:String='';

  dialogComponentInput: ModelDialogType = {
    type: null,
    message: ''
  };

  codeIcon:string='Java_icon';

  private readonly WARNING: string = 'warning';
  private readonly SUCCESS: string = 'check_circle';
  private readonly ERROR: string = 'error';

  constructor(
    private commonsvc: CommonService,
    private router: Router,
    private dialog: MatDialog,
    private _element: ElementRef,
    private customTranslateSvc: CustomTranslateService,
    private _overlayContainer: OverlayContainer,
    private settingsSvc: SettingsService,
    private dialogService: DialogService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private languageSettings: LanguageSettings,
    private searchDataService: SearchDataService ) {
      this.matIconRegistry.addSvgIcon(
        "class_icon",
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/classIcon.svg")
      );
      this.matIconRegistry.addSvgIcon(
        "enum_icon",
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/enumIcon.svg")
      );
      this.matIconRegistry.addSvgIcon(
        "interface_icon",
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/interfaceIcon.svg")
      );
      this.matIconRegistry.addSvgIcon(
        "tutorial_icon",
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/tutorialsIcon.svg")
      );
      this.matIconRegistry.addSvgIcon(
        "Java_icon",
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/language-icons/icons8-java.svg")
      );
      this.matIconRegistry.addSvgIcon(
        "Swift_icon",
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/language-icons/icons8-swift.svg")
      );
      this.matIconRegistry.addSvgIcon(
        "JavaScript_icon",
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/language-icons/icons8-javascript.svg")
      );
      this.matIconRegistry.addSvgIcon(
        "Dart_icon",
        this.domSanitizer.bypassSecurityTrustResourceUrl("../assets/images/language-icons/icons8-dart.svg")
      );
      this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((e: any) => {
        this.currentRoutePath = this.router.url.slice(6);
      });
    }

  /**
    * Tracks the currently active page and updates the Help window content accordingly.
     */
  ngOnInit() {
      this.loadSettings();
      this.currentLanguage = this.customTranslateSvc.getCurrentLanguage();
      console.log("router current name: " + this.router.url);
      this.toggle = true;

      if (this.router.url.includes('edge'))
        this.commonsvc.getMenuEdgeContent().subscribe(d => this.menuList = d);
      else
        this.commonsvc.getMenuContent().subscribe(d => this.menuList = d);

      this.screenWidth = window.innerWidth;
      window.onresize = () => {
        this.screenWidth = window.innerWidth;
      };

      this.dialogService.getData().subscribe((data: ModelDialogType) => {
        this.setDialogInput(data);
      });

      this.platforms = this.languageSettings.getAllLanguages();
      if (this.router.url.includes('edge')){
        this.platforms.splice(2,2); //remove javascript & dart since we are not currently documenting for edge
      }else this.platforms.splice(3,1); //remove dart since we are not currently documenting for sgconnect

      //if our chosen language no longer exists when switching to another product, 'reset' language settings
      if (this.platforms.includes(this.languageSettings.getSelectedLanguage()))
        this.changePlatform(this.languageSettings.getSelectedLanguage());
      else this.changePlatform('Java')

  }

  onTopClicked() {
    const top = document.getElementById('PageTop');
    if (top !== null) {
      top.scrollTo({top: 0, behavior: 'auto'});
      this.router.navigate(['/' + this.currentRoutePath.split('#')[0]], {fragment : 'PageTop'});
    }
  }

  changePlatform(platform){
    console.log("changed language to: " + platform);

    this.languageSettings.setSelectedLanguage(platform);
    this.selectedPlatform = platform;
    this.codeIcon = platform + '_icon';
  }

 loadSettings() {
    this.settingsSvc.getAll().then((settings: SettingswithID) => {

      if (settings !== undefined) {
        this.changeLang(settings.lang);
        this.toggleTheme(settings.theme);
      }else {
        this.settingsSvc.add({
          lang: this.lang,
          theme: this.darkThemeClass
        });
      }
    });
  }

  updateSettings() {
    this.settingsSvc.update(1, {
      lang: this.lang,
      theme: this.darkThemeClass
    });
  }

  gotoDashboard() {
    this.router.navigate(['/docs']);
  }

  /**
   * This function is used to change the language based upon the selection
   */
  changeLang(lang: string) {
    this.lang = lang;
    this.customTranslateSvc.switchLanguage(lang);
    this.updateSettings();
  }


  logout() { this.router.navigate(['/login']); }

/**
 * This function is used to open the model dialog box
    * Opens  {@link AboutUsDialogComponent} .
     */
  openAboutUsDialog() {
    const dialogRef = this.dialog.open(AboutUsDialogComponent, {
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

/**
   * This function is used to open the password model dialog box
    * Opens  {@link ChangePasswordDialogComponent} .
     */
  openChangePasswordDialog() {

    const dialogRef = this.dialog.open(ChangePasswordDialogComponent, {
      height: '350px'
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }

  toggleFullscreen() {
    const elem = this._element.nativeElement.querySelector('.demo-content');
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullScreen) {
      elem.webkitRequestFullScreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.msRequestFullScreen) {
      elem.msRequestFullScreen();
    }
  }

  /**
   * This function is used to change the theme.
   */
  toggleTheme(themeClass: string) {
    this._element.nativeElement.classList.remove(this.darkThemeClass);
    this._overlayContainer.getContainerElement().classList.remove(this.darkThemeClass);
    this.darkThemeClass = themeClass;
    this._element.nativeElement.classList.add(this.darkThemeClass);
    this._overlayContainer.getContainerElement().classList.add(this.darkThemeClass);
    this.updateSettings();
  }

  /**
   * This function is used to set the input of the Dialog component
   */
  private setDialogInput(inputData: ModelDialogType) {
    this.dialogComponentInput = inputData;
    switch (inputData.type) {
      case 1:
        return this.dialogComponentInput.icon = this.SUCCESS;
      case 2:
        return this.dialogComponentInput.icon = this.WARNING;
      case 3:
        return this.dialogComponentInput.icon = this.ERROR;
    }
  }
}


/**
    * Displays about us dialog window with company details.
     */
@Component({
  selector: 'app-about-us-dialog',
  templateUrl: './aboutusDialog.html',
  styleUrls: ['./aboutusDialog.css']
})
export class AboutUsDialogComponent extends Constants { }

/**
    * Displays changepassword dialog window where the current password can be updated.
     */
@Component({
  selector: 'app-change-password-dialog',
  templateUrl: 'changepasswordDialog.html',
})
export class ChangePasswordDialogComponent extends Constants {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;


/**
     * If empty, notifies 'required' error.
     */
  oldPasswordControl = new FormControl('', [Validators.required, Validators.maxLength(10)]);
  /**
     * If empty, notifies 'required' error.
     *
     * Notifies if pattern mismatch occurs.
     */
  newPasswordControl = new FormControl('', [Validators.required, Validators.pattern(this.EMAIL_REGEX)]);
   /**
     * If empty, notifies 'required' error.
     *
     * Notifies if pattern mismatch occurs.
     */
  confirmPasswordControl = new FormControl('', [Validators.required, Validators.pattern(this.EMAIL_REGEX)]);
}
